export default "__VITE_ASSET__ur4Rwdo7__"